export const BASE_URL = process.env.NODE_ENV === "production" ? "https://lunarpad.herokuapp.com/api" : "http://localhost:8000/api"
export const PAYMENT_LINK = "https://buy.stripe.com/7sI6qy3Bw5Ek6RObII";
